export default "__VITE_ASSET__Xzs70XdI__"